import { forwardRef } from "react";
import { Box, Stack } from "@mui/system";
import FeatureCard, { IFeatureCardProps } from "../featuresCard";
import styles from "./styles";
import two_stars_align_right from "assets/two_stars_align_right.webp";
import two_stars_align_left from "assets/two_stars_align_left.webp";
type IFeaturesSectionProps = {
  isSM: boolean;
  smPad: string;
  widePad: string;
  features: IFeatureCardProps[];
};
const FeaturesSection = forwardRef(
  ({ isSM, smPad, widePad, features }: IFeaturesSectionProps, ref) => {
    const classes = styles();
    return (
      <Stack
        direction={"column"}
        alignItems={"center"}
        textAlign={"center"}
        sx={{
          marginTop: { xs: "80px", sm: "100px", md: "220px" },
          position: "relative",
          padding: isSM ? smPad : `0px ${widePad}`
        }}
      >
        <img
          loading="lazy"
          src={two_stars_align_left}
          alt={"two stars align left"}
          className={classes.starsLeft}
        />
        <img
          loading="lazy"
          src={two_stars_align_right}
          alt={"Two stars"}
          className={classes.starsRight}
        />
        <Box
          sx={{
            marginBottom: "80px"
          }}
        >
          <h2 ref={ref as any} className={classes.featureTitle}>
            Our Features
          </h2>
          <p className={classes.featuresSectionDescription}>
            Build a community and create a fun Slack channel for all workspace
            members to recognize great work
          </p>
        </Box>
        {features.map((feat, idx) => (
          <FeatureCard
            {...feat}
            key={idx}
            cardDirection={
              isSM ? "column" : idx % 2 === 1 ? "row" : "row-reverse"
            }
          />
        ))}
      </Stack>
    );
  }
);

export default FeaturesSection;
